/* eslint-disable one-var */
(function () {
  'use strict';

  const UNSAVED_MODAL_PREFIX = 'ce.configuracao.vehicleSettings.unsavedChangesModal';

  class VehicleSettingsProfileCtrl {
    constructor($scope, $rootScope, $location, $window, $safetyService, Authenticator, Keys, ServiceVfiltro,
        FactoryVfiltro, $state, $stateParams, ModalInfoConfirmService, $translate) {
      this.scope = $scope;
      this.rootScope = $rootScope;
      this.location = $location;
      this.window = $window;
      this.safetyService = $safetyService;
      this.authenticator = Authenticator;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.state = $state;
      this.stateParams = $stateParams;
      this.modalInfoConfirmService = ModalInfoConfirmService;
      this.translate = $translate;
      this.user = {};
      this.isDirty = false;
      this.allowLeave = false;

      this.registerUnsavedChangesGuard();

      this.authenticator.getUser()
        .then(user => {
          this.user = user;

          ServiceVfiltro.init(FactoryVfiltro.get([
            {
              key: this.keys.uo.name
            }
          ]))
          .then((filtro) => {
            this.filtro = filtro;
            this.initializePage(this.serviceVfiltro.getFiltroBackendNovo(this.filtro));
          });
        });
    }

    // The React editor holds an unsaved draft in its own store and reports its dirty state through the
    // onDirtyChange prop. We must guard on BOTH ui-router events because, under ui-router 0.2.x, they cover
    // different navigation triggers:
    //   - $stateChangeStart fires before a $state.go / ui-sref transition (menu links) — the only point at which
    //     we can stop it, because the state transitions before the URL updates.
    //   - $locationChangeStart fires before the URL commits on a browser/mouse back button — $stateChangeStart is
    //     too late there because the URL has already changed.
    // Preventing one stops the other from firing for the same navigation, so there is no double prompt.
    // Navigations the editor itself triggers (onBack) are pre-authorized via allowLeave.
    registerUnsavedChangesGuard() {
      const unregisterState = this.rootScope.$on(
        '$stateChangeStart',
        (event, toState, toParams, fromState, fromParams) => {
          if (!this.shouldGuard() || this.isSameProfile(toState, toParams, fromState, fromParams)) {
            return;
          }
          event.preventDefault();
          this.confirmUnsavedChanges(() => this.state.go(toState.name, toParams));
        }
      );

      const unregisterLocation = this.rootScope.$on('$locationChangeStart', (event, newUrl, oldUrl) => {
        if (!this.shouldGuard() || this.isSamePath(newUrl, oldUrl)) {
          return;
        }
        event.preventDefault();
        this.confirmUnsavedChanges(() => {
          const target = new this.window.URL(newUrl);
          this.location.url(target.pathname + target.search + target.hash);
        });
      });

      this.scope.$on('$destroy', () => {
        unregisterState();
        unregisterLocation();
      });
    }

    shouldGuard() {
      return this.isDirty && !this.allowLeave;
    }

    isSameProfile(toState, toParams, fromState, fromParams) {
      return Boolean(fromState) && toState.name === fromState.name &&
        Boolean(toParams) && Boolean(fromParams) && toParams.profileId === fromParams.profileId;
    }

    isSamePath(newUrl, oldUrl) {
      try {
        return new this.window.URL(newUrl).pathname === new this.window.URL(oldUrl).pathname;
      } catch (e) {
        return false;
      }
    }

    openUnsavedConfirm() {
      return this.modalInfoConfirmService.confirmModal({
        title: this.translate.instant(`${UNSAVED_MODAL_PREFIX}.title`),
        conteudo: this.translate.instant(`${UNSAVED_MODAL_PREFIX}.description`),
        btnPrimario: this.translate.instant(`${UNSAVED_MODAL_PREFIX}.discardLabel`),
        btnSecundario: this.translate.instant(`${UNSAVED_MODAL_PREFIX}.deployFirstLabel`),
        headerColor: 'vehicle-settings-unsaved-header',
        typeButton: 'btn-danger'
      });
    }

    confirmUnsavedChanges(onDiscard) {
      this.openUnsavedConfirm()
      .then(() => {
        this.isDirty = false;
        this.allowLeave = true;
        onDiscard();
      })
      .catch(() => {});
    }

    initializePage(filter) {
      this.safetyService.initialize()
      .then(() => this.loadPage(filter));
    }

    loadPage(filter) {
      const appName = 'safetyApp',
          componentPath = './VehicleSettingsProfileEditor',
          componentId = 'safety-app-vehicle-settings-profile',
          props = {
            user: this.user,
            uoId: filter.uo_permissao,
            profileId: this.stateParams.profileId,
            onBack: () => {
              this.allowLeave = true;
              this.state.go('root.vehicleSettings');
            },
            onDirtyChange: (isDirty) => {
              this.isDirty = isDirty;
            }
          };
      this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
    }
  }
  VehicleSettingsProfileCtrl.$inject = ['$scope', '$rootScope', '$location', '$window', 'safetyService',
    'Authenticator', 'Keys', 'ServiceVfiltro', 'FactoryVfiltro', '$state', '$stateParams',
    'ModalInfoConfirmService', '$translate'];
  angular
    .module('vehicleSettings')
    .controller('VehicleSettingsProfileCtrl', VehicleSettingsProfileCtrl);
}());
